<h2 i18n mat-dialog-title>About info</h2>
<mat-dialog-content>
    <dl>
        <dt i18n>Backend</dt>
        <dd i18n>{{ backendVersion }}</dd>

        <dt i18n>Frontend</dt>
        <dd>{{ frontendVersion }}</dd>
    </dl>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button i18n mat-raised-button mat-dialog-close color="primary" cdkFocusInitial>Close</button>
</mat-dialog-actions>
